// Must stay the first import: it removes an action link's alias from the URL before the router and the trackers read it
import '@eu/app/actionLinks/captureAlias.js'
import { createApp } from 'vue'
import { consumeLpPainLocationFromUrl } from '@shared/lpPainLocation.js'
import App from '@eu/app/App.vue'
import initRouter from '@eu/app/router'
import i18n from '@shared/localization'
import { initApi } from '@shared/api-client'
import Tracker from '@shared/Tracker'
import directives from '@shared/directives'
import { generateSignupContext } from '@shared/utils'
import { createPinia } from 'pinia'
import { createPersistedState } from 'pinia-plugin-persistedstate'
import useEuStore from '@eu/app/stores/useEuStore.js'
import usePersistedConfigStore from '@shared/stores/usePersistedConfigStore.js'
import useCorporateStore from '@shared/stores/useCorporateStore.js'
import useSharedStore from '@shared/stores/useSharedStore.js'
import useUserStore from '@shared/stores/useUserStore.js'
import useFeatureFlagStore from '@shared/stores/useFeatureFlagStore'

// Before the router and trackers start: they must never see the LP answer.
consumeLpPainLocationFromUrl()

const app = createApp(App)

const pinia = createPinia()
pinia.use(createPersistedState())

Object.keys(directives).forEach((key) => {
  app.directive(key, directives[key])
})

app.use(pinia)
const euStore = useEuStore()

app.use(i18n)
const router = initRouter()
app.use(router)

Tracker.initDatadog()
const sharedStore = useSharedStore()
const userStore = useUserStore()
Tracker.initSnowplow({
  persistedConfigStore: usePersistedConfigStore(),
  corporateStore: useCorporateStore(),
  sharedStore,
  userStore,
  featureFlagStore: useFeatureFlagStore(),
  router,
})
Tracker.initMatomo({ sharedStore, userStore, router })
initApi()

euStore.updateSignupContext(generateSignupContext())

const appSpinner = document.querySelector('#app-spinner')
if (appSpinner != null) {
  appSpinner.parentNode.removeChild(appSpinner)
}

app.mount('#app')

export default app
